//@flow
// import React from 'react';
import Store from './auth-store';
// import Dispatcher from 'app/Dispatcher';
import {
  Actions
} from './auth-actions'
import {
  Cookies
} from 'react-cookie';

class Validator {

  static isLoggedIn(): boolean {
    if (this.getToken()) {
      return true;
    }
    return false;
  }

  static unsetToken() {
    Actions.unsetToken();
  }

  static getToken(): ? string {

    // console.log(process.env)
    if (process.env.DEV_MODE === 'true') {
      console.warn("OVERRIDE TOKEN");
      return process.env.DEV_TOKEN;
    }

    //try from Store
    let token = Store.getState().get('token');
    if (token) return token;

    // try from cookie
    let cookies = new Cookies();
    token = cookies.get('token');
    if (token) {
      // we want to keep using this token in this session
      Actions.setToken(token)
      return token;
    }

    //try from URL
    token = Validator.findGetParameter('token');
    if (token) {
      // we want to keep using this token in this session
      Actions.setToken(token)
      //
      return token;
    }


    // on fail return
    // somewhere here we redirect to login screen
    console.error("No token found");
    // console.log(window.location.href);

    let url = "https://auth.indemand.digital/gettoken.hh?r=" + window.location.href;
    // console.log(url);
    window.location.replace(url);
    return null;
  }

  static findGetParameter(parameterName: string) {
    let result = null,
      tmp = [];
    window.location.search
      .substr(1)
      .split("&")
      .forEach(function(item) {
        tmp = item.split("=");
        if (tmp[0] === parameterName) result = decodeURIComponent(tmp[1]);
      });
    return result;
  }


}
export default Validator;